/* this file is transformed by vux-loader */
/* eslint-disable */
import http from '../axios';
import apiUrl from '../apiUrl';
export var apiclueList = function apiclueList() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.clueList,
    method: 'get',
    params: query
  });
};
export var apiclue = function apiclue() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: apiUrl.clue,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apigetBulidType = function apigetBulidType() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.getBulidType,
    method: 'get',
    params: query
  });
};
export function getAreaList(data) {
  return http.request({
    url: '/area/list',
    method: 'get',
    params: data
  });
}
export function getAreaInfo(data) {
  return http.request({
    url: '/area/info',
    method: 'get',
    params: data
  });
}
/**
 * @params {string} tmplId - 节点模板id
 * @description 字段排序列表
 */
export function getV2FiledSortTmplFieldList(data) {
  return http.get('/fieldSort/tmplFieldList', {
    params: data
  });
}
/**
 * @description 上传签名
 */
export function postUploadSaveStr(data) {
  return http.post('/upload/save/str', data, {
    headers: {
      _noCancel: true
    }
  });
}
export function getV2SendRevisedOrderTmplFields(data) {
  return http.get('/v2/sendRevisedOrder/tmpl/fields', {
    params: data
  });
}
export function postChildrenAccountAnonymousLogin(data) {
  return http.post('/children/account/anonymousLogin', data);
}
export function postChildrenAccountAnonymousBind(data) {
  return http.post('/children/account/anonymousBind', data);
}